import { render, staticRenderFns } from "./Bands.vue?vue&type=template&id=55a39136&scoped=true&"
import script from "./Bands.vue?vue&type=script&lang=js&"
export * from "./Bands.vue?vue&type=script&lang=js&"
import style0 from "./Bands.vue?vue&type=style&index=0&id=55a39136&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a39136",
  null
  
)

export default component.exports